import React from 'react';
import SkapaButton from 'ui/Button/Button';
import SkapaTooltip from 'ui/Tooltip/SkapaTooltip';

export type SceneActionProps = {
  label: string;
  onClick: () => void;
  ssrIcon: (...args: any[]) => any;
  enabled?: boolean;
  dataTestId?: string;
};

const SceneAction: React.FC<SceneActionProps> = ({
  label,
  onClick,
  ssrIcon,
  enabled,
  dataTestId,
  ...props
}) => {
  return (
    <SkapaTooltip
      tooltipText={label}
      tooltipButtonLabel={label}
      position="trailing"
      interactiveCustomTrigger
    >
      <SkapaButton
        {...props}
        size="small"
        iconOnly
        inverseTheme={!enabled}
        type="primary"
        onClick={onClick}
        ssrIcon={ssrIcon}
        dataTestId={dataTestId}
        text={label}
        aria-pressed={enabled}
      />
    </SkapaTooltip>
  );
};

export default SceneAction;
